"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpRequester = void 0;
const cross_fetch_1 = __importDefault(require("cross-fetch"));
const Browser_1 = require("../utils/Browser");
/**
 * Responsible for making web requests.
 *
 */
class HttpRequester {
    post(url, body, headers) {
        const data = JSON.stringify(body);
        if ((0, Browser_1.isFirefox)()) {
            // send via beacon if the browser is using firefox since it does not support fetch w/keepalive
            var enqueuedEvent = navigator.sendBeacon(url, data);
            if (enqueuedEvent) {
                return Promise.resolve(new Response(null, { status: 204 }));
            }
            else {
                // If there was a failure enqueing the event just reject
                // with a Response that indicates an error. 
                // Fetch by default does not reject promises and instead just 
                // handles errors with a successful promise with an error that 
                // indicates an error
                return Promise.resolve(Response.error());
            }
        }
        else {
            const fetchInit = {
                method: 'POST',
                headers,
                body: data,
                keepalive: true
            };
            if (typeof (window) !== 'undefined' && window.fetch) {
                return window.fetch(url, fetchInit);
            }
            return (0, cross_fetch_1.default)(url, fetchInit);
        }
    }
    get(url) {
        const fetchInit = {
            method: 'GET',
            mode: 'no-cors',
            keepalive: true,
        };
        if (typeof (window) !== 'undefined' && window.fetch) {
            return window.fetch(url, fetchInit);
        }
        return (0, cross_fetch_1.default)(url, fetchInit);
    }
}
exports.HttpRequester = HttpRequester;
//# sourceMappingURL=HttpRequester.js.map